import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.firstElementChild && !window.location.pathname.startsWith("/admin")) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  container.replaceChildren();
  ReactDOM.createRoot(container).render(tree);
}
